<div class="file--info u-flex u-justifyBetween">
  <div class="u-flex">
    <i
      class="icon icon--medium file--info__icon"
      data-test-id="fileUploaderPdfIcon"
      >pdf</i
    >
    <p class="t-data t-bold" data-test-id="fileUploaderProgressFileName">
      {{ file.name }}
    </p>
  </div>
  <p class="t-data file--info__size" data-test-id="fileUploaderSize">
    {{ size }}
  </p>

  <zip-button
    [config]="{
      level: 'text',
      icon: 'close',
    }"
    (zipButtonClicked)="closeClicked.emit()"
    data-test-id="fileUploaderCloseButton"
  >
  </zip-button>
</div>

<div class="progressbar">
  <div class="progressbar__total">
    <div
      [ngClass]="{ progressbar__error: error }"
      class="progressbar__partial"
      [ngStyle]="progressWidth"
    ></div>
  </div>
  @if (!error) {
    <p
      class="t-data t-alt progressbar__percentage"
      data-test-id="fileUploaderProgressPercentage"
    >
      {{ percentComplete }} done
    </p>
  }
</div>
